import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { Routes } from '@/config/routes';
import { useAtom } from 'jotai';
import { authorizationAtom } from '@/store/authorization-atom';

const IndicacaoPage = () => {
  const router = useRouter();
  const [isAuthorized] = useAtom(authorizationAtom);

  useEffect(() => {
    const currentUrl = window.location.search;

    let referralCode = '';
    if (currentUrl) {
      const utmIndex = currentUrl.indexOf('&utm_campaign');
      if (utmIndex !== -1) {
        referralCode = currentUrl.substring(1, utmIndex);
      }
    }

    // If user is already logged in, redirect to friends indication page
    if (isAuthorized) {
      router.replace(Routes.friendsIndication);
      return;
    }

    // If user is not logged in, redirect to home with register modal
    const redirectUrl = referralCode
      ? `${Routes.home}?referral_code=${encodeURIComponent(referralCode)}&open_register=true`
      : Routes.home;

    router.replace(redirectUrl);
  }, [router, isAuthorized]);

  // Show loading while redirecting
  return (
    <div className="flex items-center justify-center min-h-screen">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-accent mx-auto mb-4"></div>
        <p className="text-gray-600">Redirecionando...</p>
      </div>
    </div>
  );
};

export default IndicacaoPage;
